{
  "components": {
    "work": {
      "title": "Work",
      "subtitle": "Track day-to-day execution activities across all organizations.",
      "assigneeScope": {
        "label": "Assignee scope",
        "ownershipLabel": "My items",
        "assignedToMe": "Assigned to me",
        "createdByMe": "Created by me"
      },
      "subTabs": {
        "tickets": "Tickets",
        "tasks": "Tasks",
        "actionItems": "Action Items",
        "recurringTasks": "Recurring Tasks"
      },
      "tickets": {
        "actions": {
          "new": "New Ticket"
        }
      },
      "actionItems": {
        "title": "Action Items",
        "actions": {
          "new": "New Action Item"
        },
        "noData": {
          "withoutFilters": {
            "title": "No action items found",
            "description": "No action items found for this view."
          }
        }
      },
      "recurringTasks": {
        "columns": {
          "recurrence": "Recurrence",
          "startDate": "Start Date",
          "endDate": "End Date"
        },
        "recurrenceInterval": {
          "day_one": "Every day",
          "day_other": "Every {{count}} days",
          "week_one": "Every week",
          "week_other": "Every {{count}} weeks",
          "month_one": "Every month",
          "month_other": "Every {{count}} months"
        },
        "noData": {
          "withoutFilters": {
            "title": "No recurring tasks found",
            "description": "No recurring tasks found for this view."
          }
        }
      }
    }
  }
}
